import React from 'react';

import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectOmniTicketConfiguredMessageTypes } from 'flow/selectors/queue-selectors';
import { QueueKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';

import Divider from '../ui-components/Divider';
import RouteLink from '../ui-components/RouteLink';
import SettingSection from '../Setting/SettingSection';

interface Props {
    entityKey: QueueKey;
}

const PbxWrittenMessagesSection = ({ entityKey }: Props) => {
    const { i18next } = useAppContext();

    const configuredMessageTypes = useAppSelector((state) =>
        selectOmniTicketConfiguredMessageTypes(state, entityKey),
    );

    // The queue and its channel mappings are fetched by PbxQueueRoutes before
    // this section mounts, so configuredMessageTypes is already populated.
    // Render the section only when the queue has configured written-message
    // channels.
    if (!configuredMessageTypes || configuredMessageTypes.size === 0) {
        return null;
    }

    return (
        <>
            <Divider />
            <SettingSection>
                {i18next.t('Queue.Settings.List.WrittenMessages')}
            </SettingSection>
            <RouteLink
                to={generatePath(
                    routes['pbx.queues.entityKey.settings.autoreply'],
                    { entityKey },
                )}
            >
                {i18next.t('Queue.Settings.List.WelcomeMessage')}
            </RouteLink>
        </>
    );
};

export default PbxWrittenMessagesSection;
